import { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet'
import usrico from './markers/user_loc_marker.png'
import bus_stop_loc from './bus_stops_data';
import bstp from './markers/bus_stop.png'
import polyline from '@mapbox/polyline';
import { baseURL,ogip } from '../constants';
// import buspath from './output_path';

export default function MapLeaflet(props) {
  // const haversine = require('haversine-distance');
  const [coord, setcoord] = useState({ lat: parseFloat(props.coord[0].latitude), lon: parseFloat(props.coord[0].longitude) })
  const [locdata, setlocdata] = useState(props.coord)
  const [mapcenter, setmapcenter] = useState([28.54596301484667, 77.19319704919322])
  const [fly, setfly] = useState(false)
  const [currentZoom, setCurrentZoom] = useState(17);
  const [showRoute, setShowRoute] = useState(false); // State to track if route should be visible
  const [routeData, setRouteData] = useState([]); // Store the route data
  const [currentTileLayer, setCurrentTileLayer] = useState({url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',name:'Default Map'});
  const [busiconlist, setbusiconlist] = useState({});

  const apiKeys =[
    'd6a9695a4c3a4c9aab73be579947bee6', // Primary key
    '0f1cc6918cd94aed88856faff65bfda1', // Backup key 1
    '1f93e779e4a34267a519716a33a8eda7', // Backup key 2
    '15405d978b85460c964101fa0a7b0712', // Backup key 3
  ];

  // Tile layer options (initialized with the first key, will be updated later)
  const tileLayersTemplate = (apikey) => [
    { name: 'Default Map', url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' },
    { name: 'Dark Mode', url: `https://{s}.tile.thunderforest.com/transport-dark/{z}/{x}/{y}.png?apikey=${apikey}` },
    { name: 'Atlas Style', url: `https://tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=${apikey}` },
  ];

  const [tileLayers, setTileLayers] = useState(tileLayersTemplate(apiKeys[0])); // Start with the first API key

  const verifyApiKey = async (apikey) => {
    try {
      const testUrl = `https://tile.thunderforest.com/transport-dark/1/0/0.png?apikey=${apikey}`;
      const response = await fetch(testUrl, { method: 'HEAD' }); // Make a HEAD request to avoid downloading the full tile
      return response.ok; // If the response is 200, the key works
    } catch (error) {
      console.error(`API Key Verification Error: ${error.message}`);
      return false;
    }
  };

  const initializeApiKey = async () => {
    for (let key of apiKeys) {
      const isValid = await verifyApiKey(key);
      if (isValid) {
        console.log(`API Key ${key} is valid.`);
        setTileLayers(tileLayersTemplate(key)); // Update tile layers with the valid key
        return;
      }
    }
    console.error('No valid API keys available!');
    setCurrentTileLayer({url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',name:'Default Map'}); // Reset to default map
    alert('Error: Unable to load the map. Resetting to Default.');
    
  };

  useEffect(() => {
    if (currentTileLayer.name != 'Default Map') {
    initializeApiKey(); // Verify and initialize API keys on component load
    }
  }, [currentTileLayer.name]);

  locdata.forEach((index) => {
    if (!busiconlist[index.device_name]) {
      // const busico = require(`./markers/bus_marker${index.device_name}.png`); // Dynamically require images
      let busico = index.marker_pic_url || require("./markers/bus_markerog.png");
      busico = busico.replace(ogip,baseURL)
      const busicon = new Icon({
        iconUrl: busico,
        iconSize: [45 * currentZoom / 17, 70 * currentZoom / 17],
        iconAnchor: [23 * currentZoom / 17, 67 * currentZoom / 17]
      });
      busiconlist[index.device_name] = busicon;
    }
  })

  useEffect(() => {
    setbusiconlist(busiconlist);
  }, [busiconlist]);

  const recenterMap = () => {
    setCurrentZoom(18)
    setmapcenter([position.latitude, position.longitude]);
  };

  const handleLayerChange = (layer) => {
    // Notify parent about dark mode
    if (layer.name === 'Dark Mode') {
      props.setdarkmode(true); // Enable dark mode
    } else {
      props.setdarkmode(false); // Disable dark mode
    }
  };

  useEffect(() => {
    handleLayerChange(currentTileLayer);
  }, [currentTileLayer]);

  const updatemap = async () => {
    // let closestIndex;
    let point;
    try {
      point = { "latitude": parseFloat(props.busdata.latitude), "longitude": parseFloat(props.busdata.longitude) }
    } catch (error) {
      point = { "latitude": parseFloat(coord.lat), "longitude": parseFloat(coord.lon) }
    }

    let newlocdata = props.coord
    // if (previousIndex === null) {
    //   // First iteration: Search the entire path
    //   let minDistance = Infinity;
    //   buspath.forEach((coord, index) => {
    //     const distance = haversine(point, coord);
    //     if (distance < minDistance) {
    //       minDistance = distance;
    //       closestIndex = index;
    //     }
    //   })
    // }
    // else {
    //   // Subsequent iterations: Search within 10 points of the previous closest point
    //   const startIndex = Math.max(previousIndex - 100, 0);
    //   const endIndex = Math.min(previousIndex + 100, buspath.length - 1);

    //   let minDistance = Infinity;
    //   for (let i = startIndex; i <= endIndex; i++) {
    //     const distance = haversine(point, buspath[i]);
    //     if (distance < minDistance) {
    //       minDistance = distance;
    //       closestIndex = i;
    //     }
    //   }
    // }

    // Full traverse
    // let minDistance = Infinity;
    // buspath.forEach((coord, index) => {
    //   const distance = haversine(point, coord);
    //   if (distance < minDistance) {
    //     minDistance = distance;
    //     closestIndex = index;
    //   }
    // })

    // let closestPoint = buspath[closestIndex];
    // console.log({ lat: closestPoint.latitude, lon: closestPoint.longitude })
    // setcoord({ lat: closestPoint.latitude, lon: closestPoint.longitude })
    setcoord({ lat: point.latitude, lon: point.longitude })
    setlocdata(newlocdata)
    // Testing Purpose only 
    // console.log(closestPoint.latitude,closestPoint.longitude)
    //

    // setpreviousIndex(closestIndex)
  }
  const movemap = async () => {
    let hdist = Math.abs((parseFloat(coord.lon) - mapcenter[1])) * 350000
    let vdist = Math.abs((parseFloat(coord.lat) - mapcenter[0])) * 350000

    if (hdist > (window.innerWidth * 0.55) || vdist > (window.innerHeight * 0.55)) {
      setmapcenter([parseFloat(coord.lat), parseFloat(coord.lon)])
      setfly(true)
    }
  }

  // const busicon = new Icon({
  //   iconUrl: busico,
  //   iconSize: [70, 80],
  //   iconAnchor: [35, 70]

  // })

  const usricon = new Icon({
    iconUrl: usrico,
    iconSize: [45 * currentZoom / 17, 45 * currentZoom / 17],

  })
  const bstpicon = new Icon({
    iconUrl: bstp,
    iconSize: [80 * currentZoom / 17, 80 * currentZoom / 17],
    iconAnchor: [35 * currentZoom / 17, 70 * currentZoom / 17]

  })
  useEffect(() => {
    updatemap()
    movemap()
  }, [props.coord, mapcenter])

  // getting user location
  const [position, setPosition] = useState(null);
  function FlyMapTo() {
    const map = useMap()
    useEffect(() => {
      map.flyTo(mapcenter, currentZoom)
      setfly(false)
    }, [mapcenter])
  }

  // Fetch the nearest route from OSRM API
  const fetchRoute = async (latitude, longitude, ulat, ulong) => {
    const url = `https://router.project-osrm.org/route/v1/driving/${longitude},${latitude};${ulong},${ulat}?overview=full`;
    const response = await fetch(url);
    const data = await response.json();
    // console.log(url)
    // Check if the API returned a valid route
    if (data.routes && data.routes.length > 0) {
      // const routeCoordinates = data.routes[0].geometry.coordinates.map(coord => [coord[1], coord[0]]);
      const routeCoordinates = polyline.decode(data.routes[0].geometry);
      setRouteData(routeCoordinates); // Set the route data to state
    } else {
      console.error("No route found.");
    }
  };

  // Track zoom level changes
  const ZoomTracker = () => {
    const map = useMap();
    useEffect(() => {
      const handleZoom = () => {
        setCurrentZoom(map.getZoom());
      };

      map.on('zoomend', handleZoom);

      return () => {
        map.off('zoomend', handleZoom);
      };
    }, [map]);

    return null;
  };

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setPosition({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not available in your browser.");
    }
  });
  return (
    <MapContainer id='mappy'
      style={{ height: window.innerHeight * 0.76 - 40, width: window.innerWidth * 0.96 }}
      center={[mapcenter[0], mapcenter[1]]}
      zoom={currentZoom}
      scrollWheelZoom={true}
    >
      <TileLayer
        // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        // url="https://{s}.tile.thunderforest.com/transport-dark/{z}/{x}/{y}.png?apikey=d6a9695a4c3a4c9aab73be579947bee6"
        // url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        url={currentTileLayer.url}
      />
      {/* Display Route */}
    {showRoute && (
      <Polyline positions={routeData} color="blue" weight={4} />
    )}

      {position && <Marker position={[position.latitude, position.longitude]} icon={usricon}>
        <Popup>
          You are here
        </Popup>
      </Marker>}
      {locdata.map((element) => (
        <Marker
          key={element.device} // Use a unique key for each Marker
          position={[element.latitude, element.longitude]}
          icon={busiconlist[element.device_name]}
        >
          <Popup>
            {element.device_name} is here
          </Popup>
          {/* <Circle center={[coord.lat+0.00003, coord.lon-0.00005]} radius={10} fillColor='blue' /> */}
        </Marker>
      ))};
      {bus_stop_loc.map((bsl) => {
        // console.log(bsl)
        return (
          <Marker id={bsl.name} position={[bsl.latitude, bsl.longitude]} icon={bstpicon} key={bsl.name}>
            <Popup>
              Bus stop : {bsl.name}
            </Popup>
          </Marker>)
      })}
      {fly && <FlyMapTo />}
      {/* Recenter button */}
      <button
        onClick={recenterMap}
        style={{
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          backgroundColor: 'white',
          border: 'none',
          padding: '5px',
          fontSize: '16px',
          cursor: 'pointer',
          borderRadius: '50%',
          zIndex: 1000,
          transition: 'transform 0.2s',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        title="Recenter"
      >
        <img src={require("./markers/recenter.png")} alt="recenter" style={{ width: "50px", height: "50px", padding: "0" }} />
      </button>
      {/* Show route button */}
      <button
        onClick={() => {
          setShowRoute(!showRoute);
          try {
            fetchRoute(coord.lat,coord.lon,position.latitude, position.longitude); // Fetch the route when clicked
          } catch (error) {
            if (position === null) {
              alert("Please enable location access and try again.");
            } 
            else {
            alert("Error fetching route. Please try again later.");
          }
        }}}
        style={{
          position: 'absolute',
          bottom: '80px',
          left: '10px',
          backgroundColor: 'white',
          border: 'black',
          borderStyle: 'solid',
          padding: '10px',
          fontSize: '16px',
          cursor: 'pointer',
          borderRadius: '50%',
          zIndex: 1000,
          transition: 'transform 0.2s',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
        title={showRoute ? "Hide Route" : "Show Route"}
      >
        <img src={require("./markers/route.png")} alt="route" style={{ width: "35px", height: "35px", padding: "0" }} />
      </button>
      {/* Layer Selector */}
      <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 500 }}>
      <select
        style={{
          padding: '10px',
          borderRadius: '5px',
          border: '1px solid #ccc',
          cursor: 'pointer',
        }}
        value={currentTileLayer.url} // Set the value to the url of the current tile layer
        onChange={(e) => {
          const selectedLayer = tileLayers.find(layer => layer.url === e.target.value);
          setCurrentTileLayer(selectedLayer); // Update the state with the selected layer object
        }}
      >
        {tileLayers.map((layer) => (
          <option key={layer.name} value={layer.url}>
            {layer.name}
          </option>
        ))}
      </select>
    </div>
      <ZoomTracker />
    </MapContainer >
    
  )
}

